const FORBIDDEN_CHARS_IN_STRINGS_REGEX = /[<>]/g;
const HTML_TAGS_REGEX = /<\/?[^>]+(>|$)/g;

export const stripHtmlTags = (myStr: string) => {
  let res = myStr.replace(HTML_TAGS_REGEX, ""); // remove any html <x> tags
  res = res.replace(FORBIDDEN_CHARS_IN_STRINGS_REGEX, "");
  return res;
};
